import { cn } from "../utils";

export const Avatar = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    className={cn(
      "bg-popover capitalize flex flex-none font-semibold h-[2em] items-center justify-center outline outline-background-contrast overflow-hidden relative rounded-full shadow-xs select-none text-[0.875em] w-[2em]",
      className
    )}
    {...props}
  />
);
